import React, {useState } from "react";
import VerticalTabs from '../../components/VerticalTabs'

const TeacherExperiences = ({teacher}) => {
    const sub_menus = [
        {
            "slug": "jobs",
            "menu_text": "Jobs"
        },
        {
            "slug": "projects",
            "menu_text": "Projects"
        },
        {
            "slug": "trainings",
            "menu_text": "Trainings"
        },
        {
            "slug": "workshops",
            "menu_text": "Workshops"
        }
    ];

    const [activeSubMenu, setActiveSubMenu] = useState(sub_menus[0].slug);

    return (
    <div>        
        <div className="nw-flex-h flex-no-wrap col-gap-default">
            <div>
                <VerticalTabs menus={sub_menus} activeMenu={activeSubMenu} setActiveMenu={setActiveSubMenu} placement="left" alignment="right" spacing=".5em"/>
            </div>
            <div className="nw-unit nw-unit-grow">
                {activeSubMenu === "jobs" && 
                    <div>
                        {
                            teacher.jobs?.length? 
                            teacher.jobs.map((c) =>    (
                                <div className="teacher-data-item">
                                    <h5>{c.duration}</h5>
                                    <h3>{c.job_title}</h3>
                                    <h6>{c.org}</h6>
                                </div>
                            ))
                            : (<p className="no-data">No job information...</p>)
                        }


                    </div>
                }
                {activeSubMenu === "projects" && 
                    <div>
                        {
                            teacher.funded_projects?.length? 
                            teacher.funded_projects.map((p) =>    (
                                <div className="teacher-data-item">
                                    {p.funds && (<h5>{p.funds}</h5>)}
                                    <h3>{p.project_url? (<a href={p.project_url} target="_blank">{p.project_title}</a>) : p.project_title}</h3>
                                    {p.description && (<h6>{p.description}</h6>)}
                                    {p.grant_no && (<p><strong>Grant no:&nbsp;</strong>{p.grant_no}</p>)}
                                    {p.grant_amount && (<p><strong>Grant amount:&nbsp;</strong>{p.grant_amount}</p>)}
                                </div>
                            ))
                            : (<p className="no-data">No project information...</p>)
                        }
                    </div>
                }
                {activeSubMenu === "trainings" && 
                    <div>
                        {
                            teacher.trainings?.length? 
                            teacher.trainings.map((t) =>    (
                                <div className="teacher-data-item">
                                    {t.dates && (<h5>{t.dates}</h5>)}
                                    <h3>{t.title}</h3>
                                    {t.description && (<h6>{t.description}</h6>)}
                                    {t.venue && (<p><strong>Venue:&nbsp;</strong>{t.venue}</p>)}
                                </div>
                            ))
                            : (<p className="no-data">No training information...</p>)
                        }
                    </div>
                }
                {activeSubMenu === "workshops" && 
                    <div>
                        {
                            teacher.workshops?.length? 
                            teacher.workshops.map((w) =>    (
                                <div className="teacher-data-item">
                                    {w.dates && (<h5>{w.dates}</h5>)}
                                    <h3>{w.title}</h3>
                                    {w.description && (<h6>{w.description}</h6>)}
                                    {w.venue && (<p><strong>Venue:&nbsp;</strong>{w.venue}</p>)}
                                </div>
                            ))
                            : (<p className="no-data">No workshop information...</p>)
                        }
                    </div>
                }
            </div>
        </div>
        
        
    </div>
    )
};

export default TeacherExperiences;
